import { DateTime } from "luxon";

export const shortDate = (isoTimestamp) => {
  const dt = DateTime.fromISO(isoTimestamp);
  return dt.toLocaleString(DateTime.DATE_SHORT);
};
export const shortDateTime = (isoTimestamp) => {
  const dt = DateTime.fromISO(isoTimestamp);
  return dt.toLocaleString(DateTime.DATETIME_SHORT);
};
export const monthYear = (isoTimestamp) => {
  const dt = DateTime.fromISO(isoTimestamp);
  return dt.toLocaleString({ month: "long", year: "numeric" });
};
export const fullDate = (isoTimestamp) => {
  const dt = DateTime.fromISO(isoTimestamp);
  return dt.toLocaleString(DateTime.DATE_FULL);
};
export const fullDateTime = (isoTimestamp) => {
  const dt = DateTime.fromISO(isoTimestamp);
  return dt.toLocaleString(DateTime.DATETIME_FULL);
};
export const time = (isoTimestamp) => {
  const dt = DateTime.fromISO(isoTimestamp);
  return dt.toLocaleString(DateTime.TIME_SIMPLE);
};
export const dateAtTime = (isoTimestamp) => {
  const dt = DateTime.fromISO(isoTimestamp);
  return dt.toFormat("cccc, LLLL d, y @ t ZZZZ");
};
export const mediumDate = (isoTimestamp) => {
  const dt = DateTime.fromISO(isoTimestamp);
  return dt.toLocaleString(DateTime.DATE_MED);
};
export const mediumDateTime = (isoTimestamp) => {
  const dt = DateTime.fromISO(isoTimestamp);
  return dt.toLocaleString(DateTime.DATETIME_MED);
};
